import { ActivatedRoute } from '@angular/router';
import { createAction, props } from '@ngrx/store';

import { JobMatchedCandidatesFilter } from './matched-candidates-filter.reducer';

export const jobFilterSet = createAction(
  '[Job Matched Candidates Filter] Set',
  props<{ jobFilter: Partial<JobMatchedCandidatesFilter>; route?: ActivatedRoute; queryParams? }>(),
);

export const jobFilterUpdate = createAction(
  '[Job Matched Candidates Filter] Update',
  props<{ filter: JobMatchedCandidatesFilter }>(),
);

export const jobFilterStateSuccess = createAction(
  '[Job Matched Candidates Filter] Set Success',
  props<{ filter: JobMatchedCandidatesFilter }>(),
);

export const jobFilterSetInitialState = createAction(
  '[Job Matched Candidates Filter] Set Initial State',
  props<{ route?: ActivatedRoute; queryParams? }>(),
);

export const jobFilterSetInitialStateSuccess = createAction(
  '[Job Matched Candidates Filter] Set Initial State Success',
  props<{
    changedInitialState: Partial<JobMatchedCandidatesFilter>;
    route?: ActivatedRoute;
    queryParams?;
  }>(),
);

export const setInitialAggregationValuesForJob = createAction(
  '[Job Matched] Set Initial State Success',
);
